import { render, staticRenderFns } from "./UserCreated.vue?vue&type=template&id=57a62f44&scoped=true&"
import script from "./UserCreated.vue?vue&type=script&lang=js&"
export * from "./UserCreated.vue?vue&type=script&lang=js&"
import style0 from "./UserCreated.vue?vue&type=style&index=0&id=57a62f44&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57a62f44",
  null
  
)

export default component.exports